import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import modelIndex from '@/components/modelIndex'
import modelView from '@/components/modelView'
import store from '../store'
import NotFound from '@/components/partials/NotFound'
import RoomWrapper from '@/components/RoomWrapper'
import Settings from '@/components/Settings'
import Schools from '@/components/Schools'
import School from '@/components/School'
import NewSchool from '@/components/NewSchool'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Rum',
      component: Dashboard,
      meta: {
        inMenu: true,
        icon: 'fa fa-bed',
        group: 'Innehåll',
        apiEndpoint: 'rooms'
      }
    },
    {
      path: '/users/:id',
      name: 'User',
      component: modelView,
      props: true,
      meta: {
        apiEndpoint: 'users'
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: modelIndex,
      props: true,
      meta: {
        inMenu: true,
        group: 'Admin',
        icon: 'fa fa-users',
        apiEndpoint: 'users',
        fields: {
          attributes: ['uuid', 'name'],
          labels: {
            uuid: 'Id',
            name: 'Title',
            email: 'E-mail',
            created_at: 'Created'
          }
        }
      }
    },
    {
      path: '/rooms/:title',
      name: 'Room',
      component: RoomWrapper,
      props: true,
      meta: {
        apiEndpoint: 'rooms'
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      props: true,
      meta: {
        apiEndpoint: 'settings',
        fields: {
          attributes: ['uuid', 'key', 'value'],
          labels: {
            uuid: 'Id',
            key: 'Namn',
            value: 'Värde',
            created_at: 'Created'
          }
        }
      }
    },
    {
      path: '/schools/new',
      name: 'NewSchool',
      component: NewSchool,
      props: true,
      meta: {
        apiEndpoint: 'schools',
        fields: {
          attributes: ['id', 'name', 'description'],
          labels: {
            uuid: 'Id',
            key: 'Namn',
            value: 'Beskrivning',
            created_at: 'Created'
          }
        }
      }
    },
    {
      path: '/schools/:id',
      name: 'School',
      component: School,
      props: true,
      meta: {
        apiEndpoint: 'schools',
        withParam: true,
        fields: {
          attributes: ['id', 'name', 'description'],
          labels: {
            uuid: 'Id',
            key: 'Namn',
            value: 'Beskrivning',
            created_at: 'Created'
          }
        }
      }
    },
    {
      path: '/schools',
      name: 'Schools',
      component: Schools,
      props: true,
      meta: {
        apiEndpoint: 'schools',
        fields: {
          attributes: ['id', 'name', 'description'],
          labels: {
            uuid: 'Id',
            name: 'Namn',
            description: 'Beskrivning',
            created_at: 'Created',
            actions: 'Verktyg'
          }
        }
      }
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})
router.beforeEach((to, from, next) => {
  store.commit('clearMessages', {})
  store.commit('resetRoomData')
  store.dispatch('fetchData', { self: to }).then(() => {
    console.log('Data laddat')
    next()
  })
})
export default router
